import { datadogRum } from '@datadog/browser-rum';
import config from './config';

if (config.Environment === 'production') {
  datadogRum.init({
    applicationId: config.Datadog.ApplicationId,
    clientToken: config.Datadog.ClientToken,
    site: 'datadoghq.eu',
    service: 'web-app',
    env: config.Environment,
    version: config.AppVersion,
    sampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    trackInteractions: true,
    excludedActivityUrls: [/.*dataplane.rum.eu-west-1.amazonaws.com.*/],
  });
}
